module.exports = __webpack_public_path__ + "img/IMG_5110.3a9d78d2.jpg";